export default function displayWeekDay(positional /*, positionalB, named*/) {
  let date = positional;
  if (typeof date === 'string') {
    // If the input is a string, parse it to a Date object
    date = new Date(date);
  }
  switch (date.getDay()) {
    case 0:
      return 'Sonntag';
    case 1:
      return 'Montag';
    case 2:
      return 'Dienstag';
    case 3:
      return 'Mittwoch';
    case 4:
      return 'Donnerstag';
    case 5:
      return 'Freitag';
    case 6:
      return 'Samstag';
    default:
      return '';
  }
}
